import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Binding
        this.onSlideChangeBind = this.onSlideChange.bind(this)
        this.slideCount = this.$('slide').length

        this.$indexes = this.$('index')
        this.currentIndex = 0

        if(this.slideCount > 0) {
            this.carousel = new Swiper(this.el, {
                slidesPerView: 1.25,
                spaceBetween: 20,
                loop: true,
                loopedSlides: this.slideCount,
                grabCursor: true,
                slideToClickedSlide: true,
                threshold: 3,
                centeredSlides: true,
                breakpoints: {
                    1000: {
                        slidesPerView: 1,
                        spaceBetween: 25
                    }
                },
                init: false
            })

            this.carousel.on('slideChange', this.onSlideChangeBind);
            this.carousel.init()
        }

        if(this.$indexes.length) {
            this.showIndex(this.$indexes[this.currentIndex])
        }
    }

    onSlideChange() {
        const previousIndex = this.currentIndex
        this.currentIndex = this.carousel.activeIndex % this.slideCount
        this.hideIndex(this.$indexes[previousIndex])
        this.showIndex(this.$indexes[this.currentIndex])
    }

    showIndex($item) {
        $item.classList.add('is-active')
    }

    hideIndex($item) {
        $item.classList.remove('is-active')
    }

    destroy() {
        super.destroy()

        if(this.slideCount > 0) {
            this.carousel.off('slideChange', this.onSlideChangeBind)
            this.carousel.destroy(true,true)
        }
    }
}
